import { defineMessages } from 'react-intl';

const messages = defineMessages({
  marketingDetails: {
    id: 'App.MarketingDetails.marketingDetails',
    defaultMessage: 'Marketing Details',
  },
  shortPropertyDescription: {
    id: 'App.MarketingDetails.shortPropertyDescription',
    defaultMessage: 'Short Property Description (on Fortress Quote)',
  },
  officeHours: {
    id: 'App.MarketingDetails.officeHours',
    defaultMessage: 'Office Hours',
  },
  propertyGallery: {
    id: 'App.MarketingDetails.propertyGallery',
    defaultMessage: 'Property Gallery',
  },
  required: {
    id: 'App.MarketingDetails.Required',
    defaultMessage: 'Field value is required.',
  },
  maxLength: {
    id: 'App.MarketingDetails.maxLength',
    defaultMessage: 'Max length is 500 characters.',
  },
  fullPropertyDescription: {
    id: 'App.MarketingDetails.FullPropertyDescription',
    defaultMessage: 'Full/Long Property Description',
  },
  petPolicyDescription: {
    id: 'App.MarketingDetails.petPolicyDescription',
    defaultMessage: 'Pet Policy',
  },
  parkingDetailDescription: {
    id: 'App.MarketingDetails.parkingDetailDescription',
    defaultMessage: 'Parking Details',
  },
  amenities: {
    id: 'App.MarketingDetails.amenities',
    defaultMessage: 'Amenities',
  },
  amenitiesPlaceholder: {
    id: 'App.MarketingDetails.amenitiesPlaceholder',
    defaultMessage: 'Select Property Amenities',
  },
});

export default messages;
